import React, { createContext, useContext } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { lightTheme } from './theme';

/**
 * The site is light-only. The context keeps its old shape (`darkMode`,
 * `toggleTheme`) so the admin pages that branch on it still compile, but
 * `darkMode` is always false and `toggleTheme` does nothing.
 */
type ThemeContextType = {
  theme: 'light';
  darkMode: false;
  toggleTheme: () => void;
};

const value: ThemeContextType = { theme: 'light', darkMode: false, toggleTheme: () => {} };

const ThemeContext = createContext<ThemeContextType>(value);

export const useAppTheme = () => useContext(ThemeContext);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeContext.Provider value={value}>
    <MuiThemeProvider theme={lightTheme}>{children}</MuiThemeProvider>
  </ThemeContext.Provider>
);
